module.exports = __webpack_public_path__ + "static/media/pistol-and-drawer-safes.9cca025a.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/model-serial-number/pistol-and-drawer-safes.png
// module id = 1299
// module chunks = 0